import React, { Component } from "react";

const inputStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
};

export class CartDetailsRows extends Component {
  handleChange = (product, event) => {
    this.props.updateQuantity(product, event.target.value);
  };

  handlePlus = (product) => {
    let quantity = parseInt(document.getElementById("quantity-input").value);
    quantity += 1;
    document.getElementById("quantity-input").value = quantity;
    this.props.updateQuantity(product, quantity);
  };

  handleDeduct = (product) => {
    let quantity = parseInt(document.getElementById("quantity-input").value);
    if (quantity === 0) {
      return;
    }
    quantity -= 1;
    document.getElementById("quantity-input").value = quantity;
    this.props.updateQuantity(product, quantity);
  };

  render() {
    if (!this.props.cart || this.props.cart.length === 0) {
      return (
        <tr>
          <td colSpan="5">Your cart is empty</td>
        </tr>
      );
    } else {
      return (
        <React.Fragment>
          {this.props.cart.map((item) => (
            <tr className="table-row" key={item.product.id}>
              <td style={inputStyle}>
                <div className="number-input">
                  <button
                    onClick={(e) => this.handleDeduct(item.product)}
                    className="deduct"
                  ></button>
                  <input
                    id="quantity-input"
                    min="0"
                    name="quantity"
                    type="number"
                    max="99"
                    step="1"
                    className="quantity quantity-input"
                    value={item.quantity}
                    onChange={(ev) => this.handleChange(item.product, ev)}
                  />
                  <button
                    className="plus"
                    onClick={(e) => this.handlePlus(item.product)}
                  ></button>
                </div>
              </td>
              <td className="product-name">{item.product.name}</td>
              <td className="price-amount">${item.product.price.toFixed(2)}</td>
              <td className="subtotal-amount">
                ${(item.quantity * item.product.price).toFixed(2)}
              </td>
              <td>
                <button
                  className="btn btn-sm btn-danger"
                  onClick={() => this.props.removeFromCart(item.product)}
                >
                  <i class="fas fa-trash"></i>
                </button>
              </td>
            </tr>
          ))}
          <tr>
            <th colSpan="3" className="text-right cart-total-text">
              Total:
            </th>
            <th colSpan="2" className="cart-total-text">
              ${this.props.cartPrice.toFixed(2)}
            </th>
          </tr>
        </React.Fragment>
      );
    }
  }
}
